export default {
  'dept.title': 'Название региона',
  'dept.btn.add': 'Добавить область',
  'dept.btn.addSubsidiary': 'Добавить дочернюю компанию',
  'dept.btn.edit': 'Редактировать компанию',
  'dept.btn.del': 'Удалить компанию',
  'dept.input.dept.placeholder': 'Название компании обязательно',
};
